var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_c('p',{staticClass:"close",on:{"click":function($event){return _vm.closeModal()}}},[_vm._v(" ×")]),_c('img',{attrs:{"src":require("../../assets/cert/certLabBarragan.jpg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }